import { useNavigate } from 'react-router';

import { BuildWorkspace } from '@/components/build-workspace/build-workspace';

/**
 * `/templates/new` — the create-new-template flow. Mounts the Build
 * workspace with no initial template; back returns the user to the landing page,
 * and the first save moves them to the new template's own URL.
 */
export function TemplateNewPage() {
  const navigate = useNavigate();
  return (
    <BuildWorkspace
      initialTemplate={null}
      onCreated={(templateId) => navigate(`/templates/${templateId}`, { replace: true })}
      onBack={(publishedTemplateId) =>
        navigate(
          '/',
          publishedTemplateId ? { state: { activatedId: publishedTemplateId } } : undefined,
        )
      }
    />
  );
}
